<template>

		<div class="list--view">
            <div class="single--list-view single--list-view-projects">
                <vs-select
                    class="selectExample"
                    v-model="selectTypeProjects"
                    @input="statusSelected"
                >
                    <vs-select-item
                        :is-selected="item.isSelected"
                        :key="index"
                        :value="item.value"
                        :text="item.label"
                        v-for="(item,index) in optionsTypeProjects" />
                </vs-select>
            </div>
        </div>
</template>

<script>
    export default {
        data () {
            return {
                selectTypeProjects: (location.search.indexOf("archived_at") >= 0 && /archived_at=([^&]+)/.exec(location.href)[1] === "true") ? "hystorical" : "actual",
                optionsTypeProjects:[
                    {value: 'actual', label:this.__('misc.actuals'), isSelected: false },
                    {value: 'hystorical', label:this.__('misc.history'), isSelected: false },
                ],

            }
        },
        methods: {
            statusSelected(selectedOption, id) {
                if (selectedOption == "actual") {
                    location.href = app.__vue__.addParam("archived_at", "false");
                } else if (selectedOption == "hystorical") {
                    location.href = app.__vue__.addParam("archived_at", "true");
                }
            },
        },
        mounted(){
        }

    }
</script>
